import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { Loader2, Calendar } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const StaffLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/staff/auth/login`, { email, pin });
      // staff_token is now an httpOnly cookie set by the backend (XSS-resistant).
      // We only persist the staff name for greeting/UI purposes.
      localStorage.setItem("staff_name", res.data.name);
      toast.success(`Welcome, ${res.data.name}`);
      navigate("/staff/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-[#002FA7] rounded-full flex items-center justify-center mx-auto mb-4">
            <Calendar className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-xl font-bold text-zinc-900 tracking-tight">
            roster<span className="text-[#002FA7]">.ai</span> Staff Portal
          </h1>
          <p className="text-sm text-zinc-500 mt-1">View your schedule and request leave</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white border border-zinc-200 p-6 space-y-4">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded">{error}</div>
          )}
          <div>
            <Label htmlFor="staff-email" className="text-xs uppercase tracking-wide text-zinc-500">Email</Label>
            <Input id="staff-email" type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} required className="mt-1"
              placeholder="your.email@company.com" data-testid="staff-email-input" />
          </div>
          <div>
            <Label htmlFor="staff-pin" className="text-xs uppercase tracking-wide text-zinc-500">PIN</Label>
            <Input id="staff-pin" type="password" value={pin} maxLength={6}
              onChange={(e) => setPin(e.target.value)} required className="mt-1"
              placeholder="Last 4 digits of your phone" data-testid="staff-pin-input" />
            <p className="text-xs text-zinc-400 mt-1">Your PIN is the last 4 digits of your phone number, or 0000 if not set</p>
          </div>
          <Button type="submit" disabled={loading}
            className="w-full bg-[#002FA7] hover:bg-[#00227A] text-white" data-testid="staff-login-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </Button>
        </form>
        <p className="text-center text-xs text-zinc-400 mt-6">
          <a href="/" className="hover:text-zinc-600 transition-colors">Back to roster.ai</a>
        </p>
      </div>
    </div>
  );
};

export default StaffLogin;
